import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Appkit Angular imports (consistent with other modules)
import { AppNgMaterialModule } from '../app-ng-material.module';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';
import { SharedPipesModule } from '../shared/pipes/shared-pipe.module';
import { GtwSearchableSelectModule } from '../shared/_directives/gtw-searchable-select/gtw-searchable-select.module';

// Components and services
import { F1120LPCHeadersComponent } from './components/f1120-l-pc-headers/f1120-l-pc-headers.component';
import { F1120LPCHeadersService } from './services/f1120-l-pc-headers.service';
import { OnlyDigitsDirective } from './directives/only-digits.directive';
import { F4562Component } from './components/f-4562/f-4562.component';
import { F4562Service } from './components/f-4562/f-4562.service';
import { F4626Component } from './components/f-4626/f-4626.component';
import { F4626Service } from './components/f-4626/f-4626.service';
import { F8824Component } from './components/f-8824/f-8824.component';
import { F8824Service } from './components/f-8824/f-8824.service';
import { F6252Component } from './components/f-6252/f-6252.component';
import { F6252Service } from './components/f-6252/f-6252.service';
import { FSchddComponent } from './components/f-schdd/f-schdd.component';
import { FSchddService } from './components/f-schdd/f-schdd.service';
import { F4797Component } from './components/f-4797/f-4797.component';
import { F4797Service } from './components/f-4797/f-4797.service';
import { F7205Component } from './components/f-7205/f-7205.component';
import { F7205Service } from './components/f-7205/f-7205.service';
import { RelatedPartyModalComponent } from './components/related-party-modal/related-party-modal.component';
import { ICDiagnosticsService } from './components/ic-diagnostics/ic-diagnostics.service';
import { ICDiagnosticsComponent } from './components/ic-diagnostics/ic-diagnostics.component';
import { ReportableTransactionComponent } from './components/reportable-transaction/reportable-transaction.component';
import { ReportableTransactionService } from './components/reportable-transaction/reportable-transaction.service';

@NgModule({
  declarations: [
    F1120LPCHeadersComponent,
    OnlyDigitsDirective,
    F4562Component,
    F4626Component,
    F8824Component,
    F6252Component,
    FSchddComponent,
    F4797Component,
    F7205Component,
    RelatedPartyModalComponent,
    ICDiagnosticsComponent,
    ReportableTransactionComponent],
  exports: [
    F1120LPCHeadersComponent,
    OnlyDigitsDirective,
    F4562Component,
    F4626Component,
    F8824Component,
    F6252Component,
    FSchddComponent,
    F4797Component,
    F7205Component,
    RelatedPartyModalComponent,
    ICDiagnosticsComponent,
    ReportableTransactionComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppNgMaterialModule,
    AppNgAppkitModule,
    SharedComponentsModule,
    SharedDirectivesModule,
    SharedPipesModule,
    GtwSearchableSelectModule],
  providers: [
    F1120LPCHeadersService,
    F4562Service,
    F4626Service,
    F8824Service,
    F6252Service,
    FSchddService,
    F4797Service,
    F7205Service,
    ICDiagnosticsService,
    ReportableTransactionService],
})
export class GtwFormsModule { }
